import { LayoutPanelLeft, Monitor, Rows3 } from "lucide-react";
import { usePosView } from "@/lib/posView";

const TITLES = { standard: "Standard View: compact layout with product cards", counter: "Counter View: large text for busy counters", full: "Full Cart View: full-width order table for many line items" };

export default function PosViewToggle({ userId }) {
  const [view, setView] = usePosView(userId);
  const opt = (v, label, Icon) => (
    <button key={v} type="button" onClick={() => setView(v)} data-testid={`pos-view-${v}`} aria-pressed={view === v}
      title={TITLES[v]}
      className={`inline-flex items-center gap-1.5 h-8 px-2.5 rounded-md text-xs font-semibold transition-colors ${
        view === v ? "bg-emerald-600 text-white shadow-sm" : "text-muted-foreground hover:text-foreground hover:bg-secondary"}`}>
      <Icon className="w-3.5 h-3.5" /><span className="hidden md:inline">{label}</span>
    </button>
  );
  return (
    <div className="inline-flex items-center gap-0.5 p-0.5 rounded-lg border border-border bg-background/60" data-testid="pos-view-toggle">
      {opt("standard", "Standard", LayoutPanelLeft)}
      {opt("counter", "Counter", Monitor)}
      {opt("full", "Full Cart", Rows3)}
    </div>
  );
}
